module.exports = __webpack_public_path__ + "img/abfb8cc.jpg";